import React, { useMemo } from "react";

function buildZigZagPath(w, h, amp = 14, step = 28) {
  // Shape like a sachet with zigzag top & bottom (simple but looks like packaging)
  const topY1 = 0;
  const topY2 = amp;
  const bottomY1 = h;
  const bottomY2 = h - amp;

  let d = `M 0 ${topY2} `;

  // top zigzag
  let x = 0;
  let up = true;
  while (x < w) {
    d += `L ${x} ${up ? topY1 : topY2} `;
    x += step / 2;
    up = !up;
  }
  d += `L ${w} ${topY2} `;

  // right side down
  d += `L ${w} ${bottomY2} `;

  // bottom zigzag (reverse)
  x = w;
  up = true;
  while (x > 0) {
    d += `L ${x} ${up ? bottomY1 : bottomY2} `;
    x -= step / 2;
    up = !up;
  }
  d += `L 0 ${bottomY2} `;

  // left side up
  d += `Z`;
  return d;
}

export default function PackagingPlaceholder({
  title = "Produk Baru",
  badge = "New",
  className = "",
}) {
  const id = useMemo(() => `clip-${Math.random().toString(16).slice(2)}`, []);
  const w = 600;
  const h = 820;

  const path = useMemo(() => buildZigZagPath(w, h), []);

  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      className={className}
      role="img"
      aria-label={title}
      style={{ width: "100%", height: "100%", display: "block" }}
    >
      <defs>
        <clipPath id={id}>
          <path d={path} />
        </clipPath>
        <linearGradient id="bgRed" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stopColor="#a00e21" />
          <stop offset="1" stopColor="#8b0c1c" />
        </linearGradient>
        <linearGradient id="bgOrange" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stopColor="#f7c948" />
          <stop offset="1" stopColor="#f59e0b" />
        </linearGradient>
      </defs>

      <g clipPath={`url(#${id})`}>
        <rect x="0" y="0" width={w} height={h} fill="#ffffff" />
        <rect x="0" y="0" width={w} height={280} fill="url(#bgRed)" />

        {/* wave */}
        <path
          d={`M 0 260 C 140 220, 260 320, 420 270 C 500 245, 560 240, ${w} 275 L ${w} 420 L 0 420 Z`}
          fill="#e11d2e"
          opacity="0.95"
        />
        <rect x="0" y="360" width={w} height={h - 360} fill="url(#bgOrange)" opacity="0.95" />

        {/* badge */}
        <g>
          <rect x="36" y="36" rx="18" ry="18" width="150" height="54" fill="#edf011" />
          <text x="58" y="72" fontSize="26" fontWeight="900" fill="#a00e21">
            {badge}
          </text>
        </g>

        {/* title */}
        <foreignObject x="40" y="150" width={w - 80} height="260">
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              color: "white",
              fontWeight: 900,
              fontSize: 40,
              lineHeight: 1.1,
              textAlign: "center",
              textShadow: "0 2px 10px rgba(0,0,0,0.18)",
              padding: "0 10px",
            }}
          >
            {title}
          </div>
        </foreignObject>

        {/* footer brand */}
        <text
          x={w / 2}
          y={h - 70}
          textAnchor="middle"
          fontSize="22"
          fontWeight="900"
          fill="#111827"
          opacity="0.8"
        >
          SHAKTI • Rempah & Bumbu
        </text>
      </g>

      {/* outline */}
      <path d={path} fill="none" stroke="rgba(0,0,0,0.12)" strokeWidth="3" />
    </svg>
  );
}
